export default __webpack_public_path__ + "static/media/default.6a6602d46b2e03925b7eac36747b32c2.png";